<template>
  <div class="document">
    <document-header :account="sender.name" description="Comprovante<br>de Devolução"></document-header>
    <div class="container">
      <div class="row row-wrap">
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Conta debitada</h4></div>
            <div class="item-box-content">
              <div class="row">
                <!-- <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ sender.document | document }}
                </div> -->
                <div class="col">
                  <h5>Conta Heppi</h5>
                  {{ sender.heppiAccount }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ sender.name }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="item-box">
            <div class="item-box-header"><h4>Favorecido</h4></div>
            <div class="item-box-content">
              <div class="row">
                <div class="col">
                  <h5>CPF/CNPJ</h5>
                  {{ receiver.document | documentMasked }}
                </div>
              </div>
              <h5>Nome</h5>
              {{ receiver.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes da Devolução</h3></div>
        <div class="item-box-content">
          <div class="row">
            <div class="col-auto pa-5">
              <div class="amount">
                {{ amount | priceInteger }}<small>,{{ amount | priceCents }}</small>
              </div>
            </div>
            <div class="col-auto pa-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMM YYYY') }}
              </div>
            </div>
            <div class="col pa-5">
              <h5>Motivo</h5>
              {{ description }}
            </div>
          </div>
        </div>
      </div>
      <div class="item-box mt-4">
        <div class="item-box-header"><h3>Detalhes da Transação</h3></div>
        <div class="item-box-content">
          <div class="row">
            <div v-if="bank" class="col-6 px-5 pt-5 pb-1">
              <h5>Conta bancária</h5>
              {{ bank.name }}
              <br>
              Agência: {{ bank.agency }}
              <br>
              Conta {{ bank.type }}: {{ bank.account }}
            </div>
             <div v-if="pix" class="col-6 px-5 pt-5 pb-1">
              <h5>PIX</h5>
              {{ pix }}
            </div>
            <div class="col-6 px-5 pt-5 pb-1">
              <h5>Titular</h5>
              {{ titular || receiver.name }}
              <br>
              CPF/CNPJ: {{ document | documentMasked }}
            </div>
            <div class="col-6 px-5 pt-1 pb-5 text-uppercase">
              <h5>Realizado em</h5>
              <div class="text-bold">
                {{ date | moment('DD MMMM YYYY HH:mm') }}
              </div>
            </div>
            <div class="col-6 px-5 pt-1 pb-5">
              <h5>Código de autenticação</h5>
              {{ mp }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import documentHeader from '@/components/documentHeader'

export default {
  name: 'transfer',
  components: {
    documentHeader
  },
  data () {
    return {
      sender: {
        name: 'MEDICINA FPS 26',
        heppiAccount: '15521340-1',
        document: '08816231483'
      },
      receiver: {
        name: 'Jefferson de Araujo Siqueira Neto',
        heppiAccount: '44356259-1',
        document: '12229654454'
      },
      description: 'Devolução desistência - Jefferson',
      document: '12229654454',
      titular: 'Jefferson de Araujo Siqueira Neto',
      amount: 4732.09,
      date: 'Mon Jul 27 2026 16:31:00 GMT-0300 (Horário Padrão de Brasília)',
      bank: {
        name: '260',
        agency: '1',
        account: '48905940-4',
        type: 'Corrente'
      },
      mp: 'E90400888202607271931YN511821995'
    }
  },
  created () {
    document.title = this.sender.name + ' - ' + this.receiver.name + ' - devolucao - ' + this.$moment(this.date).format('DD-MM-YYYY')
  }
}
</script>
